import { Lock } from 'lucide-react';
import { type ReactNode } from 'react';

import { useUsuario } from '@/lib/auth/contexto';
import { podeNaPlataforma } from '@/lib/auth/permissoes';
import { EstadoVazio } from '@/ui/components/estado-vazio';
import { type PermissaoPlataforma } from '@fiscoai/contracts';

/** Telas de administração: sem a permissão, explica em vez de mostrar um 403 cru. */
export function RequerPermissao({
  permissao,
  children,
}: {
  permissao: PermissaoPlataforma;
  children: ReactNode;
}) {
  const usuario = useUsuario();
  if (podeNaPlataforma(usuario, permissao)) return children;
  return (
    <EstadoVazio
      icone={<Lock />}
      titulo="Sem acesso a esta área"
      texto="Peça a quem administra o sistema para liberar esta permissão no seu perfil."
    />
  );
}
